module.exports = __webpack_public_path__ + "141d4a85/img/SOURCERY_poweredby_web.9819842b.png";